import { Routes, Route } from 'react-router-dom';
import Home from './routes/home/home.component';
import NavBar from './routes/navbar/navbar.component';
import Authentication from './routes/authentication/authentication.component';
import Shop from './routes/shop/shop.component';
import Checkout from './routes/checkout/checkout';
const App = () => {
  return (
    <Routes >
      <Route path='/' element={<NavBar />} >
        <Route index element={<Home/> } />
        <Route path='shop/*' element={<Shop/> } />
        <Route path='auth' element={<Authentication/> } />
        <Route path='checkout' element={<Checkout/>} />

      </Route>
    </Routes>
  );
};

export default App;
